export interface SearchFieldExpandProps {
  facet: ItemFacet
  ss: SearchStore<any>
  def: CustomSearchField
}
export function useSearchFieldExpand(props: SearchFieldExpandProps) {
  const selected = ref<string[]>([])
  const filter = ref<string>('')

  const dataStore = useDataStore()
  const { $getContentsCode, $getContentsCodeLang } = useNuxtApp()

  const contentsCode: string[] = $getContentsCode()
  const contentsCodeLang: {} = $getContentsCodeLang()

  const init = (isFacetExclude: boolean = false) => {
    let selectedValues = props.ss.state.filter[props.def.key] || []
    selected.value = selectedValues.map(s => {
      if (isFacetExclude) {
        if (s.startsWith('+') || s.startsWith('-')) {
          return s
        } else {
          return '+' + s
        }
      } else {
        if (!s.startsWith('+')) {
          return '+' + s
        } else {
          return s
        }
      }
    })
    filter.value = ''
  }

  const sortedFacet = computed(() => {
    let obj = {}
    let keys = Object.keys(props.facet.counts).filter(key => {
      let values = [key]
      switch (props.def.type) {
        case 'code':
          if (code.value) {
            let cv = code.value.values.find(v => v.code === key)
            values.push(cv.value?.ja, cv.value?.en)
          }
          break
        case 'provider':
          const provider = dataStore.provider(key)
          if (provider) {
            values.push(provider.name?.ja, provider.name?.en)
          }
          break
        case 'organization':
          const org = dataStore.organization(key)
          if (org) {
            values.push(org.name?.ja, org.name?.en)
          }
          break
        case 'contents':
          values = []
          if (contentsCode.includes(key)) {
            values.push(key)
            values.push(contentsCodeLang[key].ja, contentsCodeLang[key].en)
          }
          break
        case 'tag':
          const tag = dataStore.tag(key)
          if (tag) {
            values.push(tag.label.ja, tag.label.en)
          }
          break
        case 'database':
          const db = dataStore.database(key)
          if (db) {
            values.push(db.name.ja, db.name.en)
          }
          break
      }
      if (values.length == 0) return false
      return includes(new RegExp(filter.value, 'i'), ...values)
    })
    if (props.def.type === 'code' && code.value) {
      keys = keys.sort(
        (a, b) =>
          code.value.values.findIndex(v => v.code === a) -
          code.value.values.findIndex(v => v.code === b),
      )
    } else {
      keys = keys.sort((a, b) => props.facet.counts[b] - props.facet.counts[a])
    }
    keys.forEach(key => {
      obj[key] = props.facet.counts[key] || 0
    })
    return obj
  })

  const code = computed(() => {
    if (props.def.codeKey) return dataStore.code(props.def.codeKey)
    else return null
  })

  const showAll = computed(() => {
    return Object.keys(sortedFacet.value).length > 0
  })

  const select = (value: any) => {
    if (isSelected(value)) {
      selected.value = selected.value.filter(v => v !== '+' + value)
    } else {
      selected.value.push('+' + value)
    }
  }

  const exclude = (value: string) => {
    if (isExclude(value)) {
      selected.value = selected.value.filter(v => v !== '-' + value)
    } else {
      selected.value.push('-' + value)
    }
  }

  const isSelected = (value: any): boolean => {
    return selected.value.includes('+' + value)
  }

  const isExclude = (value: any): boolean => {
    return selected.value.includes('-' + value)
  }

  return {
    init,
    selected,
    filter,
    sortedFacet,
    code,
    showAll,
    select,
    exclude,
    isSelected,
    isExclude,
  }
}
